import FeeLevelTable from "./FeeLevelTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const FeeLevel = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_policyterm_feelevel_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) && <FeeLevelTable />}</>
  );
};

export default FeeLevel;
